import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  workshops:[],
  workshopDetails: {},
  loading: false,
  error: null,
  totalPage:1
};

const workshopSlice = createSlice({
  name: 'workshop',
  initialState,
  reducers: {
    getWorkshops(state) {
      state.loading = true;
    },
    getWorkshopsSuccess(state, action) {
      state.loading = false;
      state.workshops = action.payload.currentPage!=1? [...state.workshops, ...action.payload.data]:action.payload.data // Merge previous workshops with new data
      state.error = null;
      state.totalPage = action.payload.totalPages;
    },
    getWorkshopsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getSingleWorkshops(state) {
      state.loading = true;
    },
    getSingleWorkshopsSuccess(state, action) {
      state.loading = false;
      state.workshopDetails = action.payload;
      state.error = null;
    },
    getSingleWorkshopsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getWorkshops,
  getWorkshopsSuccess,
  getWorkshopsFailure,
  getSingleWorkshops,
  getSingleWorkshopsSuccess,
  getSingleWorkshopsFailure,
} = workshopSlice.actions;

export default workshopSlice.reducer;
